export default __webpack_public_path__ + "static/media/group30@3x.7a222cee.png";